<template>
  <RouterView />
</template>

<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const type = urlParams.get("type") ? urlParams.get("type").toLowerCase() : "";
  if (window.location.href.includes("index.html")) {
    if (type) {
      router.push({ name: "home", query: { type } });
    } else {
      router.push({ name: "home" });
    }
  }
});
</script>
